import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getProductiveCycleStageList as getProductiveCycleStageListApi,
	getProductiveCycleStage as getProductiveCycleStageApi,
	addNewProductiveCycleStage as addNewProductiveCycleStageApi,
	updateProductiveCycleStage as updateProductiveCycleStageApi,
	deleteProductiveCycleStage as deleteProductiveCycleStageApi,
} from '../../helpers/establishment/backend_helper';

export const getProductiveCycleStageList = createAsyncThunk('productiveCycleStage/getProductiveCycleStageList', async () => {
	try {
		const response = getProductiveCycleStageListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getProductiveCycleStage = createAsyncThunk('productiveCycleStage/getProductiveCycleStage', async productive_cycle_stage_id => {
	try {
		const response = getProductiveCycleStageApi(productive_cycle_stage_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewProductiveCycleStage = createAsyncThunk('productiveCycleStage/addNewProductiveCycleStage', async productive_cycle_stage => {
	try {
		const response = addNewProductiveCycleStageApi(productive_cycle_stage);
		toast.success('Estado ciclo productivo agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar productive_cycle_stage.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateProductiveCycleStage = createAsyncThunk('productiveCycleStage/updateProductiveCycleStage', async (productive_cycle_stage) => {
		try {
			const response = updateProductiveCycleStageApi(productive_cycle_stage);
			toast.success('Estado ciclo productivo actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar productive_cycle_stage.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteProductiveCycleStage = createAsyncThunk('productiveCycleStage/deleteProductiveCycleStage', async productive_cycle_stage => {
	try {
		const response = await deleteProductiveCycleStageApi(productive_cycle_stage);
		toast.success('Estado ciclo productivo eliminado exitosamente.', { autoClose: 3000 });
		return { productive_cycle_stage, ...response };
	} catch (error) {
		toast.error('Error al eliminar productive_cycle_stage.', { autoClose: 3000 });
		throw new Error(error);
	}
});
